import React, {Component} from "react";
import "./ProductHeader.css";
import DateText from "../../../common/DateText/DateText";
import EditField from "../../../common/EditField/EditField";
import Permissions from "../../../authentication/Permissions";
import AuthorizationService from "../../../services/authorization-service";
import {checkValue} from "../../../utils";

class ProductHeader extends Component {

    validType(type) {
        return type === "API" || type === "USER";
    }

    render() {
        return (
            <div className="product-header">
                <div className="row">
                    <div className="col-md-6">
                        <div className="row details-row">
                            <div className="col-md-3 details-label">Type</div>
                            <div className="col-md-9">{this.props.product.type}</div>
                        </div>
                        <div className="row details-row">
                            <div
                                className="col-md-3 details-label">{this.props.product.type === "API" ? "Service Code" : "Tenant"}</div>
                            {this.props.product.type === "API" && <div className="col-md-9">
                                <EditField
                                    value={checkValue(this.props.product.serviceCode, "No Code")}
                                    label="Service Code"
                                    editHandler={this.props.updateServiceCode}
                                    header="Update Service Code"
                                    title="Set the service code value for the product"
                                    type="text"
                                    maxLength="5"
                                    canEdit={AuthorizationService.hasPermission(Permissions.product.edit) && this.props.product.isActive}
                                />
                            </div>

                            }

                            {this.props.product.type === "USER" &&
                            <div
                                className="col-md-9">{this.props.product.appStructure === "tenant" ? "Yes" : "No"}</div>
                            }

                        </div>
                        {this.props.product.type === "USER" &&
                        <div className="row details-row">
                            <div className="col-md-3 details-label">AppName</div>
                            <div className="col-md-9">{this.props.product.appName}</div>
                        </div>
                        }
                        <div className="row details-row">
                            <div className="col-md-3 details-label">Description</div>
                            <div className="col-md-9">

                                <EditField
                                    value={checkValue(this.props.product.description, "No Description")}
                                    label="Description"
                                    editHandler={this.props.updateDescription}
                                    header="Update Description"
                                    title="Set the description value for the product"
                                    type="textarea"
                                    canEdit={AuthorizationService.hasPermission(Permissions.product.edit)}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="row details-row">
                            <div className="col-md-3 details-label">Created</div>
                            <div className="col-md-3">
                                <DateText date={this.props.product.createdAt}/></div>
                        </div>
                        <div className="row details-row">
                            <div className="col-md-3 details-label">Updated</div>
                            <div className="col-md-3">
                                <DateText date={this.props.product.updatedAt}/></div>
                        </div>
                        <div className="row details-row">
                            <div className="col-md-3 details-label">Status</div>
                            <div className="col-md-3">{this.props.product.isActive ? "Active" : "Inactive"}</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ProductHeader;



// WEBPACK FOOTER //
// ./src/products/product-details/components/ProductHeader.js